import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";


const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  heading: {
    fontWeight: "bold",
    color: theme.palette.primary.headingColor,
    fontSize: theme.spacing(3),
    marginRight: 5,
  },
  searchBox: {
    maxWidth: 300, // Adjust width of the search box
  },
  searchInput: {
    "& .MuiOutlinedInput-root": {
      marginTop: 1,
      backgroundColor: theme.palette.primary.background,
    },
  },
}));

const DashboardHeader = ({ heading }) => {
  const classes = useStyles();

  return (
    <Grid container justify="flex-end" className={classes.container}>
      {/* Heading */}
      <Grid item>
        <Typography variant="h6" className={classes.heading}>
          {heading}
        </Typography>
      </Grid>
    </Grid>
  );
};

DashboardHeader.propTypes = {
  heading: PropTypes.string,
};

export default DashboardHeader;
